'use strict';
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
    data() {
        return { qrStatusPoll: null };
    },
    computed: {
        ...mapGetters({
            errors: 'form/errors',
            isBusy: 'form/isBusy'
        }),

        userInfo() {
            return this.$store.getters['authentication/getUserInfo'];
        }
    },
    filters: {
        lowercaseFirst(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toLowerCase() + value.slice(1);
        },
        uppercaseAll(value) {
            if (!value) return '';
            return value.toUpperCase();
        },
        uppercaseFirst(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        },
        formatPhoneNumber(value) {
            return value ? (/^(\+63|0)/gi.test(value) ? value : `+63${value}`) : null;
        },
        formatMobileNumber(value, format = '') {
            if (!value) return '';

            if (format == '+63' && !value.startsWith('+63')) {
                value = value.replace(/^0/, '+63');
            }

            if (value.startsWith('+63')) {
                return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
            } else {
                return value.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
            }
        },
        formatDate(value, format = 1, hasTime = false) {
            if (!value) {
                return '';
            } else if (value == '-') {
                return;
            }

            const date = format == 1 ? 'MMM DD, YYYY' : 'DD MMM YYYY';
            const time = hasTime ? 'hh:mm A' : '';

            return moment(value).format(`${date} ${time}`);
        }
    },
    methods: {
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name === name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        // Pasa yung action_key - permissions = list / permission kung ano yung hanap
        isPermitted(permissions, permission) {
            if (typeof permissions === 'object') {
                return permission in permissions && permissions[permission] === true ? true : false;
            }

            return false;

            // const permittedPermissions = userInfo.roles.findIndex((role) => {
            //     return role.permissions[permission]; // will return -1 if not found
            // });

            // return permittedPermissions >= 0;
        },

        formatCurrency(value) {
            return this.$options.filters.formatCurrency(value);
        },
        formatNumberInComma(value) {
            return this.$options.filters.formatNumberInComma(value);
        },
        // Dynamic Navigation
        navigation(trigger, params, replace = true) {
            let path = this.$route.name == 'my-qr' ? 'merchants' : this.$route.path;
            let routeArr = path.split('/');
            const actions = ['add', 'edit', 'view', 'create', 'invite-user', 'import'];
            const action = routeArr.filter((element) => actions.includes(element)).pop();
            const splice = routeArr.lastIndexOf(action);

            if (trigger != 'to' && this.userInfo && this.userInfo.role.id == 'MERCHANT' && this.$route.path.indexOf('branches') == -1) {
                return '/my-qr';
            }

            switch (trigger) {
                case 'back':
                    routeArr.splice(splice);
                    break;
                case 'cancel':
                    if (action == 'edit') {
                        routeArr[routeArr.lastIndexOf('edit')] = 'view';
                    } else {
                        routeArr.splice(splice);
                    }
                    break;
                case 'to':
                    if (splice != -1 && replace) {
                        routeArr.splice(splice);
                    }

                    routeArr = routeArr.concat(params);
                    break;
            }

            return routeArr.join('/');
        },
        notification(payload) {
            const { type, message, title } = payload;

            console.log(payload);
            if (message) {
                this.$notify({
                    group: 'main-notifications',
                    type: type ? type : 'success',
                    duration: 5000,
                    title: title ? title : this.$router.history.current.meta.moduleTitle || 'Content Management',
                    text: message ? message : ''
                });
            }
        },
        setIsBusy(value) {
            this.$store.commit('form/SET_IS_BUSY', value);
        },
        //filter paste to be postive number
        filterPasteAcceptPositive(e) {
            let clipboardData = e.clipboardData || window.clipboardData;
            let text = parseInt(clipboardData.getData('Text'));
            if (isNaN(text) || text < 1) {
                e.preventDefault();
            }
        }
    }
};
